import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import CoursePage from "@/pages/CoursePage";
import CartPage from "@/pages/CartPage";
import SuperProfilePage from "@/pages/SuperProfilePage";
import OnePercentClubPage from "@/pages/OnePercentClubPage";
import AdminLogin from "@/pages/AdminLogin";
import { AdminForgotPassword, AdminResetPassword } from "@/pages/AdminPasswordReset";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import LegalPage from "@/pages/LegalPage";
import StudentLogin from "@/pages/StudentLogin";
import StudentRegister from "@/pages/StudentRegister";
import StudentForgotPassword from "@/pages/StudentForgotPassword";
import StudentSetPassword from "@/pages/StudentSetPassword";
import StudentResetPassword from "@/pages/StudentResetPassword";
import StudentDashboard from "@/pages/StudentDashboard";
import StudentCoursePlayer from "@/pages/StudentCoursePlayer";
import CertificatePage from "@/pages/CertificatePage";
import { CartProvider } from "@/lib/cart";
import { StudentAuthProvider } from "@/lib/student-auth";
import { hydratePricing } from "@/lib/pricing";
import { captureCouponFromURL } from "@/lib/coupon-capture";

function PricingBoot() {
  useEffect(() => {
    hydratePricing();
  }, []);
  return null;
}

function ThemeBoot() {
  useEffect(() => {
    const saved = localStorage.getItem("sp-theme");
    const prefers = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const theme = saved || (prefers ? "dark" : "light");
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, []);
  return null;
}

function CouponCapture() {
  useEffect(() => {
    captureCouponFromURL();
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <ThemeBoot />
      <BrowserRouter>
        <CartProvider>
          <StudentAuthProvider>
          <CouponCapture />
          <PricingBoot />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/super-profile-program" element={<SuperProfilePage />} />
            <Route path="/1-percent-community-club" element={<OnePercentClubPage />} />
            <Route path="/courses/:slug" element={<CoursePage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/certificate/:certId" element={<CertificatePage />} />
            <Route path="/success" element={<PaymentSuccessPage />} />
            <Route path="/terms-and-conditions" element={<LegalPage slug="terms-and-conditions" />} />
            <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
            <Route path="/refund-policy" element={<LegalPage slug="refund-policy" />} />
            {/* Backward-compatible short aliases */}
            <Route path="/terms" element={<LegalPage slug="terms-and-conditions" />} />
            <Route path="/privacy" element={<LegalPage slug="privacy-policy" />} />
            <Route path="/refund" element={<LegalPage slug="refund-policy" />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route path="/admin" element={<AdminDashboard />} />
            {/* Student panel */}
            <Route path="/student/login" element={<StudentLogin />} />
            <Route path="/student/register" element={<StudentRegister />} />
            <Route path="/student/forgot-password" element={<StudentForgotPassword />} />
            <Route path="/student/set-password" element={<StudentSetPassword />} />
            <Route path="/student/reset-password" element={<StudentResetPassword />} />
            <Route path="/student/learn/:slug" element={<StudentCoursePlayer />} />
            <Route path="/student" element={<StudentDashboard />} />
            <Route path="/student/:section" element={<StudentDashboard />} />
          </Routes>
          </StudentAuthProvider>
        </CartProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="system"
        toastOptions={{
          style: { borderRadius: "14px", fontFamily: "Inter, sans-serif" },
        }}
      />
    </div>
  );
}

export default App;
